import types from '../mutation-types';
import PlatformTooltipsAPI from '../../api/platformTooltips';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    hasFetched: false,
  },
};

export const getters = {
  getByIdentifier: $state => identifier => {
    return $state.records[identifier] || null;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  hasFetched($state) {
    return $state.uiFlags.hasFetched;
  },
};

export const actions = {
  fetch: async function fetchTooltips({ commit, state: $state }) {
    // Avoid re-fetching if already loaded or currently loading (race condition guard)
    if ($state.uiFlags.hasFetched || $state.uiFlags.isFetching) return;

    commit(types.SET_PLATFORM_TOOLTIPS_UI_FLAG, { isFetching: true });
    try {
      const response = await PlatformTooltipsAPI.get();
      const tooltipsMap = {};
      const tooltips = response.data || [];
      tooltips.forEach(tooltip => {
        if (tooltip.identifier) {
          tooltipsMap[tooltip.identifier] = {
            message: tooltip.message || '',
            url: tooltip.url || '',
          };
        }
      });
      commit(types.SET_PLATFORM_TOOLTIPS, tooltipsMap);
    } catch (error) {
      // Silently fail — tooltips are non-critical
    } finally {
      commit(types.SET_PLATFORM_TOOLTIPS_UI_FLAG, {
        isFetching: false,
        hasFetched: true,
      });
    }
  },
};

export const mutations = {
  [types.SET_PLATFORM_TOOLTIPS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_PLATFORM_TOOLTIPS]($state, tooltipsMap) {
    $state.records = tooltipsMap;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
